import { ICartItem, IInsuranceCartItem } from '@ApiModels/viewCart';
import { POSTPAID_PLAN } from '@Config/app.config';
import { ICheckout } from '@Redux/modules/checkout/actions';
import { IHbbWfbbProcessCheckout } from '@Redux/modules/persistentCheckoutData/actions';
import { BUY_HBB, BUY_WFBB } from '@Views/Map/Map';

export const getShipmentArgs = (shipmentAddress: ICheckout['payload']['shipmentAddress']): string[] => {
	const args = [];
	if (shipmentAddress?.city) {
		args.push(shipmentAddress.city);
	}
	if (shipmentAddress?.area) {
		args.push(shipmentAddress.area);
	}
	if (shipmentAddress?.way) {
		args.push(shipmentAddress.way);
	}
	if (shipmentAddress?.house) {
		args.push(shipmentAddress.house);
	}
	if (shipmentAddress?.apartment) {
		args.push('/' + shipmentAddress.apartment);
	}
	return args;
};

export const getcontactDetailsArgs = (contactDetails: ICheckout['payload']['contactDetails']): string[] => {
	const args = [];
	if (contactDetails?.firstName) {
		args.push(contactDetails.firstName);
	}
	if (contactDetails?.middleName) {
		args.push(contactDetails.middleName);
	}
	if (contactDetails?.lastName) {
		args.push(contactDetails.lastName);
	}
	return args;
};

export const getHbbWfbbContactDetailsArgs = (hbbWfbbProcessCheckout: IHbbWfbbProcessCheckout | undefined): string[] => {
	const args = [];
	if (hbbWfbbProcessCheckout?.firstName) {
		args.push(hbbWfbbProcessCheckout.firstName);
	}
	if (hbbWfbbProcessCheckout?.middleName) {
		args.push(hbbWfbbProcessCheckout.middleName);
	}
	if (hbbWfbbProcessCheckout?.lastName) {
		args.push(hbbWfbbProcessCheckout.lastName);
	}
	return args;
};

export const getInternetInstallationAddressSubtitleArgs = (
	hbbWfbbProcessCheckout: IHbbWfbbProcessCheckout | undefined
): string[] => {
	const args = [];
	if (hbbWfbbProcessCheckout?.region) {
		args.push(hbbWfbbProcessCheckout.region);
	}
	if (hbbWfbbProcessCheckout?.wayNumber && hbbWfbbProcessCheckout?.wayNumber !== 'null') {
		args.push(hbbWfbbProcessCheckout.wayNumber);
	}
	if (hbbWfbbProcessCheckout?.buildingNumber && hbbWfbbProcessCheckout?.buildingNumber !== 'null') {
		args.push(hbbWfbbProcessCheckout.buildingNumber);
	}
	return args;
};

export const isPlanIncluded = (items: (ICartItem | IInsuranceCartItem)[]): boolean =>
	items.some((item) => item.withPlan && ![BUY_HBB, BUY_WFBB].includes(item.plan?.PA || ''));

export const isPrepaidIncluded = (items: (ICartItem | IInsuranceCartItem)[]): boolean =>
	items.some((item) => item.withPlan && [POSTPAID_PLAN].includes(item.plan?.PA || ''));
